var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6665 8.00098H40.6665C42.8757 8.00098 44.6665 9.79184 44.6665 12.001V36.001C44.6665 38.2102 42.8757 40.001 40.6665 40.001H8.6665C6.45736 40.001 4.6665 38.2102 4.6665 36.001V12.001C4.6665 9.79184 6.45736 8.00098 8.6665 8.00098ZM27.9665 30.901L40.6665 22.001V17.801L25.9665 28.101C25.1847 28.6436 24.1483 28.6436 23.3665 28.101L8.6665 17.801V22.001L21.3665 30.901C23.3485 32.2864 25.9845 32.2864 27.9665 30.901Z",
    fill: "#000099"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3f8853f73513f95464f0b3eb1c991632.svg";
export { ForwardRef as ReactComponent };